import { render } from "./Customization.vue?vue&type=template&id=914e3676"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"
script.render = render

export default script